import { DASHED, DOTTED, NONE, SOLID } from '../store/borderStyle'
import { t } from 'plottr_locales'

import { getTextColor } from './colors'

/**
 * @typedef {import('../store/borderStyle').LineStyle} LineStyle
 * @typedef {import('../index').HierarchyLevel} HierarchyLevel
 */

/**
 * @param {LineStyle} borderStyle
 * @return {'solid' | 'dashed' | 'dotted' | 'none'}
 */
export const borderStyleToCss = (borderStyle) => {
  switch (borderStyle) {
    case NONE:
      return 'solid'
    case DASHED:
      return 'dashed'
    case SOLID:
      return 'solid'
    case DOTTED:
      return 'dotted'
    default:
      return 'none'
  }
}

/**
 * @param {String} color
 * @return {String | Null}
 */
const nullIfNone = (color) => (color === 'none' ? null : color)

/**
 * @param {LineStyle} borderStyle
 * @param {String} borderColor
 * @return {'transparent' | String}
 */
const noneIsTransparent = (borderStyle, borderColor) => {
  return borderStyle === NONE || borderColor === 'none' ? 'transparent' : borderColor
}

/**
 * @typedef HierarchyStyles
 * @property {String} [color]
 * @property {String} lineHeight
 * @property {String} [backgroundColor]
 * @property {String} [border]
 * @property {String} [fontSize]
 */

/**
 * @param {HierarchyLevel} arg
 * @param {'small' | 'medium' | 'large'} timelineSize
 * @param {boolean} hovering
 * @param {HierarchyLevel['dark'] | HierarchyLevel['light']} theme
 * @param {boolean} isDarkMode
 * @return {HierarchyStyles}
 */
export const hierarchyToStyles = (
  { textSize, borderStyle, backgroundColor },
  timelineSize,
  hovering,
  theme,
  isDarkMode
) => {
  const b = nullIfNone(backgroundColor)
  const c = nullIfNone(getTextColor(theme.textColor, isDarkMode))
  return {
    ...{
      ...(c ? { color: c } : {}),
      lineHeight: `${textSize}px`,
      ...(b ? { backgroundColor: b } : {}),
    },
    ...(!hovering
      ? {
          border: `3px ${borderStyleToCss(borderStyle)} ${noneIsTransparent(
            borderStyle,
            theme.borderColor
          )}`,
        }
      : {}),
    ...(timelineSize === 'large'
      ? {
          fontSize: `${textSize}px`,
        }
      : {}),
  }
}

/**
 * @param {number | 'default'} depth
 * @return {String}
 */
export const nextLevelName = (depth) => {
  const LEVEL_NAMES = [t('Scene'), t('Chapter'), t('Act')]
  if (depth == 'default') return t('Chapter')
  return LEVEL_NAMES[depth] || `Level-${depth + 1}`
}
